// @flow

// This component renders DoubleClick floodlight tags in a sandboxed iframe

import * as React from 'react';

type Props = {|
  owner: string, // The client/owner of the pixel (Visa, Expedia, etc.)
  id: string, // e.g. DC-5524617
  pageName: string, // pageName
  contentId: string, // page content id
  country: string, // country
  language: string, // page language
  sendTo: string, // DC-5524617/tripa0/tripa0+stand
  pxlType: string, // for pixel: tripa0
  pxlCat: string, // for pixel: tripa0
|};

class FloodlightTag extends React.Component<Props> {
  static defaultProps = {
    owner: '',
    id: '',
    pageName: '',
    contentId: '',
    country: '',
    language: '',
    sendTo: '',
    pxlType: '',
    pxlCat: '',
  };

  // The floodlight tag (tracking) should only be injected once
  shouldComponentUpdate() {
    return false;
  }

  render() {
    const {
      owner,
      id,
      contentId,
      language,
      country,
      pageName,
      sendTo,
      pxlType,
      pxlCat,
    } = this.props;

    const frameParams = [
      `id=${id}`,
      `u7=${contentId}`,
      `u8=${language}`,
      `u10=${country}`,
      `u17=${pageName}`,
      `send_to=${sendTo}`,
      `type=${pxlType}`,
      `cat=${pxlCat}`,
    ];

    const staticPageVer = 2; // <-- floodlight.html is manually versioned.
    const frameUrl = `/static/solutions/floodlight.html?${frameParams.join(
      '&',
    )}&ver=${staticPageVer}`;
    return (
      <iframe
        className="floodTag"
        sandbox="allow-scripts"
        height="0"
        width="0"
        title="floodlight tag"
        src={frameUrl}
        data-owner={owner}
      />
    );
  }
}

export default FloodlightTag;
